"use strict";

$(document).ready(function () {
  $(document).click(function (e) {
    e.stopPropagation();
    var container = $(".dropdown");

    //check if the clicked area is dropDown or not
    if (container.has(e.target).length === 0) {
      $(".dropdown:not(.should-open").removeClass("is-active");
      $(".fa-flip-vertical").removeClass("fa-flip-vertical");
    }
  });
  $(".dropdown-trigger").click(function () {
    var elem = $(this).closest(".dropdown");
    $(elem).toggleClass("is-active");
    $(".fa-angle-down").toggleClass("fa-flip-vertical");
  });
  $(".tabs ul li").click(function () {
    var elem = $(this);
    var elemID = elem.attr("id");
    var tabPane = document.getElementById(elemID + "-pane");
    $(".tabs ul li").removeClass("is-active");
    elem.addClass("is-active");
    $(".tab-pane").removeClass("is-active");
    $(tabPane).addClass("is-active");
  });
  function addQuerystring(url, newstring) {
    url += url.indexOf('#') > -1 ? '&' : '#';
    return url + newstring;
  }
  var doctorCard = $('.search-card doctor');
  if (doctorCard) {
    var specialtiesSearchBtn = $('#specialtySearchBtn');
    var specialtiesDropdown = $('#specialtiesDropdown');
    var acceptingNewPatientsCheckbox = $('#acceptingNewPatientsCheckbox');
    var telehealthCheckbox = $('#telehealthCheckbox');
    var nameSearchBtn = $('#nameSearchBtn');
    var nameInput = $('#nameInput');
    specialtiesSearchBtn.on('click', function (e) {
      e.preventDefault();
      var url = window.location.href + '/find-a-doctor';
      if (specialtiesDropdown != null && specialtiesDropdown.val() != '0') {
        url = addQuerystring(url, 'f:specialties=[' + encodeURIComponent(specialtiesDropdown.val()) + ']');
      }
      if (acceptingNewPatientsCheckbox != null && acceptingNewPatientsCheckbox[0].checked) {
        url = addQuerystring(url, 'f:acceptingnewpatients=[1]');
      }
      if (telehealthCheckbox != null && telehealthCheckbox[0].checked) {
        url = addQuerystring(url, 'f:telehealth=[1]');
      }
      window.location.href = url;
    });
    nameSearchBtn.on('click', function (e) {
      e.preventDefault();
      var url = '/find-a-doctor';
      if (nameInput != null && nameInput[0].value != '') {
        url = addQuerystring(url, 'q=' + encodeURIComponent(nameInput[0].value));
      }
      window.location.href = url;
    });
  }
  var locationCard = $('.search-card hospital');
  if (locationCard) {
    var locationSearchBtn = $('#locationSearchBtn');
    var facilityTypesDropdown = $('#facilityTypesDropdown');
    var areaInput = $('#areaInput');
    locationSearchBtn.on('click', function (e) {
      e.preventDefault();
      var url = window.location.href + '/find-a-location';
      if (facilityTypesDropdown != null && facilityTypesDropdown.val() != '0') {
        url = addQuerystring(url, 'f:facilitytype=[' + encodeURIComponent(facilityTypesDropdown.val()) + ']');
      }
      if (areaInput != null && areaInput[0].value != '') {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': areaInput[0].value
        }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var coords = results[0].geometry.location;
            url = addQuerystring(url, 'f:location=' + encodeURIComponent(areaInput[0].value));
            url = addQuerystring(url, 'f:geolocation=[' + coords.lat() + ',' + coords.lng() + ']');
            window.location.href = url;
          }
        });
      } else {
        window.location.href = url;
      }
    });
  }
});
window.initLocationCard = function () {};